import { SearchHistoryResultModel } from "../Types";

export const SearchHistoryModel: SearchHistoryResultModel = {
  data: [],
  isError: false,
  isLoading: false,
};
